<template>
  <div>
    <h2>{{ $t('rechargeRecords') }}</h2>
    <div class="recharge-record container-fluid">
      <div class="recharge-title">{{ $t('rechargeRecords') }}</div>
      <div class="no-record" v-show="hasFetch && records.length === 0 && !loading">{{ $t('noRechargeRecords') }}</div>
      <div class="no-record" v-show="!hasFetch && records.length === 0">{{$t('is_loading')}}</div>

      <div id="records-list" v-if="records.length > 0">
        <div class="phone-records-row" v-for="item in records">
          <p class="plan-name">{{ item.order_detail.plan_name }}: ({{ item.order_detail.device_count }} {{ $tc('devices',item.order_detail.device_count) }})</p>
          <p>{{ $t('time') }}{{ $t(':') }}{{ item.created_at | createFormatTime(item.created_at) }}</p>
          <p>{{ $t('amount') }}{{ $t(':') }}{{ item.order_detail.currency_symbol }}{{ item.order_detail.total_amount }}</p>
          <p>{{ $t('status') }}{{ $t(':') }}{{ $t(item.status) }}</p>
          <p>{{ $t('paymentMethods') }}{{ $t(':') }}
            <template v-if="item.payment_method_id === 'alipay' || item.payment_method_id === 'wechatpay'">{{ $t(item.payment_method_id) }}</template>
            <template v-else>{{ item.payment_method_name }}</template>
          </p>
          <p class="invoice">{{ $t('invoice') }}{{ $t(':') }}<a :href="getInvoiceDownloadLink(item.id)">{{ $t('invoice') }}</a></p>
        </div>
      </div>

      <div class="spinner-box" v-show="loading"><spinner :show="loading"></spinner></div>
      <back-to-top></back-to-top>
      <load-more :current-page="currentPage" :total-page="totalPage"
                :loading="loading" @click.native="queryData" v-if="hasFetch && records.length > 0"></load-more>
    </div>
  </div>
</template>
<script>
  import {createFormatTime} from 'src/lib/filters'
  import LoadMore from '../../components/loadMore/LoadMore.vue'
  import BackToTop from '../../components/backToTop/BackToTop.vue'
  import Spinner from '../../components/Spinner.vue'
  import {getApiHost} from '../../lib/getApiHost.js'
  import locales from './lang'

  export default {
    name: 'recharge-record-m',
    components: {Spinner, BackToTop, LoadMore},
    props: ['initData', 'hasFetch'],
    data: function () {
      return {
        records: [],
        totalPage: 1,
        currentPage: 0,
        loading: false
      }
    },
    locales,
    watch: {
      initData() {
        this.records = this.initData.body.data
        this.currentPage = this.initData.body.meta['current_page']
        this.totalPage = Math.ceil(this.initData.body.meta['total'] / this.initData.body.meta['per_page'])
      }
    },
    methods: {
      queryData() {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.loading = true
        this.currentPage++
        this.$http.get('api/topup-records?page=' + this.currentPage).then((response) => {
          this.loading = false
          this.records = this.records.concat(response.data.data)
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, (response) => {
          this.loading = false
        })
      },
      getInvoiceDownloadLink(orderId) {
        return `${getApiHost()}/api/topup-order/${orderId}/invoice`
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  h2 {
    display: block;
    font-size: .24rem;
    line-height: 32px;
    color: #111111;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.24rem;
  }

  .recharge-record {
    border: 1px solid #E0D7E3;
    border-radius: .05rem;
    // min-height: calc(100vh - .6rem - .4rem - 1.2rem);
  }

  .no-record {
    margin: 40px auto;
    text-align: center;
    color: #666;
    font-size: 12px;
  }

  .recharge-title {
    height: .44rem;
    line-height: .44rem;
    padding: 0 .16rem;
    font-size: 14px;
    color: #111;
    letter-spacing: 0;
    border-bottom: 1px solid #E0D7E3;
    border-radius: 0;
  }

  #pc-records {
    display: none;
  }

  .phone-records-row {
    margin: 0 .16rem;
    border-radius: 0;
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #E0D7E3;
    }
    p {
      margin-bottom: .12rem;
      color: #333;
      line-height: .2rem;
      font-size: .14rem;
      letter-spacing: 0;
    }
    .invoice {
      margin-bottom: 0;
      a {
        color: #416CF8;
        text-decoration: underline;
      }
    }
  }

  .spinner-box {
    min-height: .6rem;
  }
</style>



// WEBPACK FOOTER //
// RechargeRecordM.vue?034c4c89